import * as types from '../types'
const state = {
  main_beautyitem: JSON.parse(localStorage.getItem('confirmResult')) || {},
  main_beautyitemstate: JSON.parse(localStorage.getItem('confirmResultstate')) || false
}
const actions = {
  set_beautyitem({commit, state}, res) {
    localStorage.setItem('confirmResult',res);
    commit(types.SET_CONFIRMRESULT_SET, res);
    commit(types.SET_CONFIRMRESULT_SET_STATE, true);
    localStorage.setItem('confirmResultstate', true);
  },
  del_beautyitem({commit, state}, res) {
    localStorage.removeItem(res);
    commit(types.SET_CONFIRMRESULT_SET, res);
    commit(types.SET_CONFIRMRESULT_SET_STATE, false);
    localStorage.setItem(res, false);
  }

}
const getters = {
  confirmResult: state => state.confirmResult,
  confirmResultstate: state => state.confirmResultstate
}

const mutations = {
  [types.SET_CONFIRMRESULT_SET](state, res) {
    state.confirmResult = res
  },
  [types.SET_CONFIRMRESULT_SET_STATE](state, res) {
    state.confirmResultstate = res
  }
}
export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/beautyitem.js